import { ReactNode } from "react";
import { isReviewMode } from "../utils/reviewMode";
import { textParser, TextParserArg } from "../utils/textParser";
import { errorNotice } from "./locale";
import { positionScale } from "../components/map/ZPostion/type";

// SVG 아이콘 컴포넌트들
const SquareLineIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 4.5H18.6667C19.1269 4.5 19.5 4.8731 19.5 5.33333V18.6667C19.5 19.1269 19.1269 19.5 18.6667 19.5H5.33333C4.8731 19.5 4.5 19.1269 4.5 18.6667V5.33333C4.5 4.8731 4.8731 4.5 5.33333 4.5ZM6.38095 6.16667C6.26261 6.16667 6.16667 6.26261 6.16667 6.38095V17.619C6.16667 17.7374 6.26261 17.8333 6.38095 17.8333H17.619C17.7374 17.8333 17.8333 17.7374 17.8333 17.619V6.38095C17.8333 6.26261 17.7374 6.16667 17.619 6.16667H6.38095Z"
      fill="currentColor"
    />
  </svg>
);

const ColumnLineIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1667 6.38095C11.1667 6.26261 11.0707 6.16667 10.9524 6.16667H6.38095C6.26261 6.16667 6.16667 6.26261 6.16667 6.38095V17.619C6.16667 17.7374 6.26261 17.8333 6.38095 17.8333H10.9524C11.0707 17.8333 11.1667 17.7374 11.1667 17.619V6.38095ZM13.0476 6.16667C12.9293 6.16667 12.8333 6.26261 12.8333 6.38095V17.619C12.8333 17.7374 12.9293 17.8333 13.0476 17.8333H17.619C17.7374 17.8333 17.8333 17.7374 17.8333 17.619V6.38095C17.8333 6.26261 17.7374 6.16667 17.619 6.16667H13.0476ZM5.33333 4.5H18.6667C19.1269 4.5 19.5 4.8731 19.5 5.33333V18.6667C19.5 19.1269 19.1269 19.5 18.6667 19.5H5.33333C4.8731 19.5 4.5 19.1269 4.5 18.6667V5.33333C4.5 4.8731 4.8731 4.5 5.33333 4.5Z"
      fill="currentColor"
    />
  </svg>
);

const Column2LineIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.38095 12.8333C6.26261 12.8333 6.16667 12.9293 6.16667 13.0476V17.619C6.16667 17.7374 6.26261 17.8333 6.38095 17.8333H17.619C17.7374 17.8333 17.8333 17.7374 17.8333 17.619V13.0476C17.8333 12.9293 17.7374 12.8333 17.619 12.8333H6.38095ZM6.16667 10.9524C6.16667 11.0707 6.26261 11.1667 6.38095 11.1667H17.619C17.7374 11.1667 17.8333 11.0707 17.8333 10.9524V6.38095C17.8333 6.26261 17.7374 6.16667 17.619 6.16667H6.38095C6.26261 6.16667 6.16667 6.26261 6.16667 6.38095L6.16667 10.9524ZM4.5 18.6667L4.5 5.33333C4.5 4.87308 4.8731 4.5 5.33333 4.5H18.6667C19.1269 4.5 19.5 4.87308 19.5 5.33333V18.6667C19.5 19.1269 19.1269 19.5 18.6667 19.5H5.33333C4.8731 19.5 4.5 19.1269 4.5 18.6667Z"
      fill="currentColor"
    />
  </svg>
);

const GridLineIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 4.5C19.1642 4.5 19.5 4.8731 19.5 5.33333V18.6667C19.5 19.1269 19.1642 19.5 18.75 19.5H5.25C4.83579 19.5 4.5 19.1269 4.5 18.6667V5.33333C4.5 4.8731 4.83579 4.5 5.25 4.5H18.75ZM11.25 13.0476C11.25 12.9293 11.1541 12.8333 11.0357 12.8333H6.21429C6.09594 12.8333 6 12.9293 6 13.0476V17.619C6 17.7374 6.09594 17.8333 6.21429 17.8333H11.0357C11.1541 17.8333 11.25 17.7374 11.25 17.619V13.0476ZM18 13.0476C18 12.9293 17.9041 12.8333 17.7857 12.8333H12.9643C12.8459 12.8333 12.75 12.9293 12.75 13.0476V17.619C12.75 17.7374 12.8459 17.8333 12.9643 17.8333H17.7857C17.9041 17.8333 18 17.7374 18 17.619V13.0476ZM11.25 6.38095C11.25 6.26261 11.1541 6.16667 11.0357 6.16667H6.21429C6.09594 6.16667 6 6.26261 6 6.38095V10.9524C6 11.0707 6.09594 11.1667 6.21429 11.1667H11.0357C11.1541 11.1667 11.25 11.0707 11.25 10.9524V6.38095ZM18 6.38095C18 6.26261 17.9041 6.16667 17.7857 6.16667H12.9643C12.8459 6.16667 12.75 6.26261 12.75 6.38095V10.9524C12.75 11.0707 12.8459 11.1667 12.9643 11.1667H17.7857C17.9041 11.1667 18 11.0707 18 10.9524V6.38095Z"
      fill="currentColor"
    />
  </svg>
);

export type Tabs = "inspection2D" | "inspection3D";

export type ChangePasswordMode = typeof SEND_CODE | typeof CHANGE_PASSWORD;

export const COGNITO_IDENTITYPOOL_ID = "identity_pool_id";
export const COGNITO_USERPOOL_ID = "user_pool_id";
export const COGNITO_USERPOOL_WEBCLIENT_ID = "user_pool_web_client_id";
export const S3_API_URL = "s3_endpoint";
export const DATA_BUCKET_NAME = "bucket_name";
export const CAPTURE_CLOUDFRONT_URL = "cloudfront_not_empty_file_url";
export const PUBLIC_STORAGE = "https://st-landing.ds-develop.com";
export const DRONESQUARE_BACKEND = "dronesquare_backend";
/** awsconfig REST 키와 모든 API.* 호출부가 공유하는 통합 게이트웨이 식별자 (DRONESQUARE_BACKEND SSM 키와 다름) */
export const DRONESQUARE_API_GATEWAY = "DronesquareApi-V1";

export const PARAMETERS = [
  COGNITO_IDENTITYPOOL_ID,
  COGNITO_USERPOOL_ID,
  COGNITO_USERPOOL_WEBCLIENT_ID,
  DATA_BUCKET_NAME,
  S3_API_URL,
  CAPTURE_CLOUDFRONT_URL,
];
export const MARKER_COLORS: MarkerColor[] = [
  "red",
  "yellow",
  "green",
  "skyblue",
  "blue",
  "brown",
];

export const LATLNG_SELECT_ITEMS: { value: positionScale; label: string }[] = [
  { value: "KOREA2000", label: "Korea2000" },
  { value: "GOOGLE", label: "Google Mercator" },
  { value: "WSG", label: "WSG 84 / LonLat" },
  { value: "UTM", label: "UTM" },
];
export const ROLE_SELECT_ITEMS = [
  {
    label: "inspector",
    value: "inspector",
  },
  {
    label: "viewer",
    value: "viewer",
  },
];

export const ISSUE_GRADE_ITEMS = {
  severity: { ko: "심각도", en: "Severity" },
  importance: { ko: "중요도", en: "Priority" },
  urgenty: { ko: "긴급도", en: "Urgency" },
};

export const TIMESERIES_PAGE_CATEGORY = {
  inspection2D: { ko: "정사영상", en: "2D Image" },
  inspection3D: { ko: "3D 모델", en: "3D Model" },
} as const;

export const ISSUE_GRADE_VALUE_COLOR = [
  // { grade: "0", color: "#fff" },
  { grade: "1", color: "#F5BB3C" },
  { grade: "2", color: "#F59700" },
  { grade: "3", color: "#C6612A" },
  { grade: "4", color: "#E63F30" },
  { grade: "5", color: "#BE3C30" },
];

type Tab = {
  ko: string;
  en: string;
};

export type CustomTabs = Record<string, Tab>;

export const MANAGE_DRONE_IMG_TABS = {
  UPLOADED_IMGS: { ko: "이미지 리스트", en: "Images" },
  PRE_UPLOAD_IMGS: { ko: "이미지 추가", en: "Image Uploading" },
};

export const MANAGE_ANNOTATION_TABS = {
  ISSUE_INFORMATION: { ko: "정보", en: "Information" },
  MEASUARMENT_INFORMATION: { ko: "측정", en: "Measurements" },
};

export const MANAGE_OTHER_DATA_TABS = {
  REFERENCE_DATA: { ko: "참고", en: "Etc Files" },
  OVERLAPPING_DATA: { ko: "레이어", en: "Overlay Layers" },
};

export const MANAGE_ANNOTATIONS_TABS = {
  ISSUE_INFORMATION: { ko: "이슈 리스트", en: "Issue Lists" },
  MEASUARMENT_INFORMATION: { ko: "측정 리스트", en: "Measurement Lists" },
};

export const MANAGE_PROJECT_TABS = {
  PROJECT: { ko: "프로젝트", en: "Project" },
  MAPPING: { ko: "시계열", en: "Time Series" },
};

export const LAYER_DESCRIPTION_NAV_ITEMS = {
  calInfoOptions: ["line", "rectangle", "polygon", "circle"],
  calPathInfoOptions: ["line", "rectangle", "polygon"],
  amountOfSectionOptions: ["rectangle", "polygon"],
  longitudinalSectionOptions: ["rectangle", "polygon"],
  crossSectionOptions: ["line"],
};
export const AUTH_GRADE = {
  GUEST: "guests",
  USER: "users",
  ADMIN: "admin",
  ROAD_DETECTION: "roadDetection",
};
export const SIGNIN_ERROR = {
  UserNotConfirmedException: {
    name: "UserNotConfirmedException",
    message: {
      ko: "인증되지 않은 사용자입니다.",
      en: "Email Confirmation is not completed.",
    },
  },
  NotAuthorizedException: {
    name: "NotAuthorizedException",
    message: { ko: "비밀번호가 일치하지 않습니다.", en: "Wrong Password" },
  },
  UserNotFoundException: {
    name: "UserNotFoundException",
    message: { ko: "존재하지 않는 사용자입니다.", en: "Wrong User ID" },
  },
  ExpiredCodeError: {
    name: "ConfirmForgotPassword",
    message: { ko: "만료된 코드입니다.", en: "The code has expired" },
  },
  EmailNotConfirmCodeError: {
    name: "UserNotConfirmedException",
    message: {
      ko: "이메일 인증을 완료해주세요.",
      en: "Please Complete the email verification",
    },
  },
};

export const EMAIL_ERROR = {
  UserNotFoundException: SIGNIN_ERROR.UserNotFoundException,
};

export const SIGNUP_ERROR = {
  UnexpectedLambdaError: {
    name: "UnexpectedLambdaException",
    message: {
      ko: "이메일 인증에 성공했으나, 예기치 않은 예외 발생.",
      en: "Email verification succeeded, but an unexpected exception occurred",
    },
  },
  EmailCodeMismatchError: {
    name: "CodeMismatchException",
    message: {
      ko: "인증번호가 일치하지 않습니다.",
      en: "The verification code does not match",
    },
  },
};

export const CHANGE_PW_CODE_ERROR = {
  CodeMismatchException: SIGNUP_ERROR.EmailCodeMismatchError,
  PassWordChangeFailedError: {
    name: "PassWordChangeFailedError",
    message: {
      ko: "비밀번호 변경에 실패했습니다. 잠시 후 다시 시도해주세요.",
      en: "Password change failed",
    },
  },
};

export type MarkerColor =
  | "red"
  | "yellow"
  | "green"
  | "skyblue"
  | "blue"
  | "brown"
  | "green";

export const QUERY_OPTIONS = {
  retry: 2,
  refetchOnWindowFocus: false,
  staleTime: 10 * 60 * 1000,
  cacheTime: 30 * 60 * 1000,
};
export const DEFAULT_MAP_LOCATION = {
  lng: 126.97,
  lat: 37.56,
};

export const BIAS_ZOOM7 = 2.2;
export const BIAS_ZOOM11 = 0.015;

export const BIAS_LAT_LON_RATIO = 1.25;

export const DEFAULT_ZOOMIMAGE_LOCATION = {
  lng: 127,
  lat: 38,
};

export const MODAL_TYPE_STYLES = {
  hasTable: {
    width: "880px",
    height: "580px",
  },
  singleInput: {
    width: "370px",
    height: "190px",
  },
  delete: {
    width: "370px",
    height: "120px",
  },
};

export const TIMESERISE_QUERY_KEYS = [
  "getTimeseriesList",
  "getNotIncludedTimeseriesList",
];

export const RANDOM_COLOR = ["blue", "red", "brown", "green", "black"];

export type TimeSeriseButtonProperty = {
  label: number;
  icon: any;
  columns: number;
  rows: number;
  buttonSize: number;
};

export const TIMESERISE_LAYOUT_BUTTONS: TimeSeriseButtonProperty[] = [
  {
    label: 0,
    icon: SquareLineIcon,
    columns: 1,
    rows: 1,
    buttonSize: 23,
  },
  {
    label: 1,
    icon: ColumnLineIcon,
    columns: 2,
    rows: 1,
    buttonSize: 23,
  },
  {
    label: 2,
    icon: Column2LineIcon,
    columns: 1,
    rows: 2,
    buttonSize: 23,
  },
  {
    label: 3,
    icon: GridLineIcon,
    columns: 2,
    rows: 2,
    buttonSize: 23,
  },
];

export const SIGNUP_FIELD = [
  { ko: "설계", en: "Design" },
  { ko: "시공", en: "Construction" },
  { ko: "유지보수", en: "Maintenance" },
  { ko: "안전진단", en: "Safety Assessment" },
  { ko: "측량", en: "Surveying" },
  { ko: "농업", en: "Agriculture" },
  { ko: "환경", en: "Environment" },
  { ko: "도시계획", en: "Urban Planning" },
  { ko: "드론운용", en: "Drone Operation" },
  { ko: "제조", en: "Manufacturing" },
  { ko: "운송", en: "Transportation" },
  { ko: "정보통신", en: "Information and Communication" },
  { ko: "공공행정", en: "Public Administration" },
  { ko: "자원개발", en: "Resource Development" },
  { ko: "기술 서비스", en: "Technical Service" },
  { ko: "기타", en: "Others" },
];

export const COORDINATE_NAMES = {
  5185: { ko: "서부원점", en: "West Belt" },
  5186: { ko: "중부원점", en: "Central Belt" },
  5187: { ko: "동부원점", en: "East Belt" },
  32648: { ko: "UTM", en: "UTM" },
};

export const DOWNLOAD_ICON = `
  <?xml version="1.0" encoding="utf-8"?>
  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 16L11.6464 16.3536L12 16.7071L12.3536 16.3536L12 16ZM12.5 4C12.5 3.72386 12.2761 3.5 12 3.5C11.7239 3.5 11.5 3.72386 11.5 4L12.5 4ZM5.64645 10.3536L11.6464 16.3536L12.3536 15.6464L6.35355 9.64645L5.64645 10.3536ZM12.3536 16.3536L18.3536 10.3536L17.6464 9.64645L11.6464 15.6464L12.3536 16.3536ZM12.5 16L12.5 4L11.5 4L11.5 16L12.5 16Z" fill="#fff"/>
  <path d="M5 21H19" stroke="#fff"/>
  </svg>`;

export const FILE_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg"
    height="15"
    width="11.5"
    viewBox="0 0 384 512"
    style="margin-top: 2px; margin-left: 2px;">
    <path d="M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l128 0 0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 32 32 32z"/>
  </svg>
`;

export const TEXT_C_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg"
    height="15"
    width="11.5"
    viewBox="0 0 384 512">
    <path d="M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"/>
  </svg>
`;

export const TEXT_D_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg"
    height="15"
    width="11"
    viewBox="0 0 384 512">
    <path d="M0 96C0 60.7 28.7 32 64 32l96 0c123.7 0 224 100.3 224 224s-100.3 224-224 224l-96 0c-35.3 0-64-28.7-64-64L0 96zm160 0L64 96l0 320 96 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z"/>
  </svg>
`;

export type ValueOf<T> = T[keyof T];

export const ANNOTATION_TYPE = {
  marker: "marker",
  line: "line",
  polygon: "polygon",
  text: "text",
  rectangle: "rectangle",
} as const;

export const PROJECT_CONDITION: {
  BEFORE: "before";
  PROCESSING: "on_processing";
  COMPLETED: "completed";
  FAILED: "failed";
  REQUESTED: "requested";
  REVIEWING: "reviewing";
  REVIEW_2D_READY: "review_2d_ready";
  REVIEW_3D_READY: "review_3d_ready";
} = {
  BEFORE: "before",
  PROCESSING: "on_processing",
  COMPLETED: "completed",
  FAILED: "failed",
  REQUESTED: "requested",
  REVIEWING: "reviewing",
  /** 검수 보류 중 2D(정사영상·DEM)까지 구축되고 mesh 는 아직 없다 — 검수 모드로 온 관리자의 요청에만 온다. */
  REVIEW_2D_READY: "review_2d_ready",
  /** 검수 보류 중 mesh 까지 변환되고 2D 는 아직 없다 — 검수 모드로 온 관리자의 요청에만 온다. */
  REVIEW_3D_READY: "review_3d_ready",
};

type TimeProjectCondition = {
  current_state: ValueOf<typeof PROJECT_CONDITION>;
};

/**
 * 회차(`time_project`)가 **완료**됐는가 — 2D 와 mesh 의 모든 산출이 있어, 토공·단면의 현황 Mesh·표면으로 계산해 저장하는 요청을
 * 포함한 모든 화면에 열거나 완료 목록에 올릴 수 있는 회차의 유일한 정의다. 2D 만으로 서는 화면은 `is2dCompletedTimeProject`,
 * mesh 만으로 서는 화면(3D 보기·측정)은 `is3dCompletedTimeProject` 를 쓴다.
 *
 * 입력은 서버가 답한 `current_state` 뿐이다. 누구에게 어떤 상태를 보일지는 서버가 정하므로(검수 보류된 회차는 검수 모드로 온
 * 관리자의 요청이 아니면 누구에게나 `on_processing` 으로 온다) 여기에 사용자 등급 분기를 더하지 않는다.
 */
export function isCompletedTimeProject(
  timeProject: TimeProjectCondition
): boolean {
  return timeProject.current_state === PROJECT_CONDITION.COMPLETED;
}

/**
 * 회차의 **2D 가 완료**됐는가 — 정사영상·DEM 만으로 서는 화면(`/timeseries`·`/worksite` 의 2D)에 열 수 있는 회차의 유일한
 * 정의다. 완료된 회차는 모두 여기 든다. 그 밖에는 검수 모드인 탭의 `review_2d_ready`(mesh 미구축) 하나다.
 *
 * 그 값은 서버가 검수 모드로 온 관리자의 요청에만 준다. 그래도 탭이 검수 모드인지를 함께 본다 — 보통 탭에 그 값이 오면(서버의
 * 결함) 모르는 상태로 두어 아무것도 열지 않는다. 탭의 모드는 서버가 준 값을 **좁히기만** 하고, 서버가 주지 않은 것을 열지
 * 않는다. 화면이 검수 모드로 가르는 자리는 이 술어와 `is3dCompletedTimeProject` 둘뿐이다.
 */
export function is2dCompletedTimeProject(
  timeProject: TimeProjectCondition
): boolean {
  return (
    isCompletedTimeProject(timeProject) ||
    (timeProject.current_state === PROJECT_CONDITION.REVIEW_2D_READY &&
      isReviewMode())
  );
}

/**
 * 회차의 **3D 가 완료**됐는가 — mesh 만으로 서는 화면(`/timeseries`·`/worksite` 의 3D 와 그 측정 도구·고도 조회)에 열 수 있는
 * 회차의 유일한 정의다. 완료된 회차는 모두 여기 든다. 그 밖에는 검수 모드인 탭의 `review_3d_ready`(2D 미구축) 하나다 — 보통 탭에
 * 그 값이 오면 `is2dCompletedTimeProject` 와 같은 까닭으로 열지 않는다.
 */
export function is3dCompletedTimeProject(
  timeProject: TimeProjectCondition
): boolean {
  return (
    isCompletedTimeProject(timeProject) ||
    (timeProject.current_state === PROJECT_CONDITION.REVIEW_3D_READY &&
      isReviewMode())
  );
}

/**
 * 회차의 매핑 입력(드론 이미지·GCP)을 바꾸거나 매핑을 요청할 수 있는가 — 처리 전과 처리 실패뿐이다. 그 밖은 모두 잠긴다:
 * 요청 뒤·처리 중·완료, 구축이 아직 끝나지 않은 `review_2d_ready`·`review_3d_ready`, 그리고 모르는 상태. 서버의 매핑 요청 가드는
 * 거절할 것만 적는다(요청됨·처리 중·검수 중 부분 완료 409, 완료 400) — 여기서 여는 둘은 늘 받아들여지고, 서버가 받는 나머지
 * 하나(`pre_processing` — 아무도 쓰지 않는다)는 화면이 먼저 잠근다.
 */
export function isMappingOpenTimeProject(
  timeProject: TimeProjectCondition
): boolean {
  return (
    timeProject.current_state === PROJECT_CONDITION.BEFORE ||
    timeProject.current_state === PROJECT_CONDITION.FAILED
  );
}

export type ModalType = {
  title: string;
  isDark?: boolean;
  doNotShowDay?: number;
  component: ReactNode;
};

export const makeModalConstants = (locale: "en" | "ko"): ModalType[] => [
  {
    title: errorNotice.title[locale],
    component: textParser(errorNotice.content[locale] as TextParserArg),
  },
];

export function getNoticeObjFromStorageObj(
  key: string
): Record<string, number> {
  const stringiedObj = localStorage.getItem(key);
  if (stringiedObj) {
    return JSON.parse(stringiedObj);
  } else {
    return {};
  }
}

export function setNoticeObjToStorageObj(
  key: string,
  noticeObj: Record<string, number>
) {
  const stringifiedNoticeObj = JSON.stringify(noticeObj);
  localStorage.setItem(key, stringifiedNoticeObj);
}

export const NETWORK_REQUEST_BATCH_LIMIT = 300;
export const NETWORK_REQUEST_GRAPH_BATCH_LIMIT = 10;

export const CROSS_LONGITUDE_GRAPH = {
  MIN_POINT_STEP: 1,
  MIN_LINE_STEP: 20,
  MAX_STEP: 100,
  STEP_INCREMENT: 5,
};

export const DXF_GRAPH = {
  MIN_POINT_STEP: 1,
  MIN_LINE_STEP: 20,
  LEFT: 10,
  RIGHT: 10,
  START_POINT: 0,
};

export const MARKER_PX_SIZE = [
  { label: "12px", value: 12 },
  { label: "13px", value: 13 },
  { label: "14px", value: 14 },
  { label: "15px", value: 15 },
  { label: "16px", value: 16 },
  { label: "17px", value: 17 },
  { label: "18px", value: 18 },
  { label: "19px", value: 19 },
  { label: "20px", value: 20 },
  { label: "21px", value: 21 },
  { label: "22px", value: 22 },
  { label: "23px", value: 23 },
  { label: "24px", value: 24 },
];

// 이메일 유효성 검사 정규식 (.co.kr 같은 다중 도메인 지원)
export const EMAIL_REG_EXP =
  /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+(\.[A-Za-z0-9\-]+)+$/;

export const SEND_CODE = "Send Code";
export const VERIFY_CODE = "Verify Code";
export const CHANGE_PASSWORD = "Change Password";
export const CHANGE_PASSWORD_STEPS: ChangePasswordMode[] = [
  SEND_CODE,
  // VERIFY_CODE,
  CHANGE_PASSWORD,
];

export type PROCESS_STATUS =
  | "COMPLETE"
  | "PROCESSING"
  | "BEFORE"
  | "ERROR"
  | "DEFAULT";

export type PROCESS_STATUS_SMALL =
  | "complete"
  | "processing"
  | "before"
  | "error"
  | "default";

export const STATUS_COLORS: Record<PROCESS_STATUS, string> = {
  COMPLETE: "#00cc66",
  PROCESSING: "#ffcc00",
  BEFORE: "#aaaaaa",
  ERROR: "#ff0000",
  DEFAULT: "transparent",
};

export const statusColorMap: Record<PROCESS_STATUS_SMALL, string> = {
  complete: STATUS_COLORS.COMPLETE,
  processing: STATUS_COLORS.PROCESSING,
  before: STATUS_COLORS.BEFORE,
  default: STATUS_COLORS.DEFAULT,
  error: STATUS_COLORS.ERROR,
};
